import React from 'react';

import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const chart = (props) => {
    return (
        <ResponsiveContainer 
            width="100%" height={300}
        >
            <BarChart
                data={props.stats.data}
                margin={{top: 10, right: 0, left: 0, bottom: 20}}
                maxBarSize={40}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey={props.stats.xKey} label={{ value: props.stats.xTitle, position: "bottom"}} tick={props.xTick} />
                <YAxis allowDecimals={false} />
                <Tooltip 
                    wrapperStyle={{
                        maxWidth: "255px",
                    }} 
                />
                <Legend 
                    verticalAlign="top" 
                    iconSize={25} 
                    wrapperStyle={{
                        paddingBottom: "20px",
                    }} 
                />
                <Bar 
                    name={props.stats.yTitle}
                    dataKey="value" 
                    fill="#80ba27" 
                />
            </BarChart>
        </ResponsiveContainer>
    )
};

export default chart;